<template>
  <canvas
    ref="chartCanvas"
    class="chart-canvas"
    height="100%"
    style="max-width: 100%; min-width: 250px"
  >
  </canvas>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import Chart from "chart.js/auto";

export default {
  name: "SteelcasePowderSavingChart",
  props: {
    datasetZero: {
      type: Number,
      required: true,
    },
    datasetOne: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const chartCanvas = ref(null);
    let chartInstance = null;

    const createBarChartConfig = () => {
      const backgroundColors = ["rgba(255, 99, 132, 0.2)", "rgba(54, 162, 235, 0.2)"];
      const borderColors = ["rgb(255, 99, 132)", "rgb(54, 162, 235)"];
      const optimizedBackgroundColors = ["rgba(54, 162, 235, 0.2)", "rgba(54, 162, 235, 0.2)"];
      const optimizedBorderColors = ["rgba(84, 182, 235, 0.8)", "rgb(84, 182, 245)"];

      return {
        type: "bar",
        data: {
          labels: ["Consumption comparison"],
          datasets: [
            {
              label: "Previous Powder consumption",
              data: [props.datasetZero],
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: 1,
            },
            {
              label: "Adjusted Powder consumption",
              data: [props.datasetOne],
              backgroundColor: optimizedBackgroundColors,
              borderColor: optimizedBorderColors,
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Total Gun throughput [g/min]",
              },
            },
          },
        },
      };
    };

    const drawBarChart = () => {
      if (!chartCanvas.value) return;

      const context = chartCanvas.value.getContext("2d");
      if (chartInstance) chartInstance.destroy();
      chartInstance = new Chart(context, createBarChartConfig());
    };

    watch(() => [props.datasetZero, props.datasetOne], drawBarChart, {
      immediate: true,
    });

    onMounted(drawBarChart);

    onBeforeUnmount(() => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    });

    return {
      chartCanvas,
    };
  },
};
</script>
